import * as PillActions from '../actions/PillActions'
export const ActionCreators = Object.assign({}, PillActions)




// WEBPACK FOOTER //
// ./js/components/actions/index.js